// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popover {
  background-color: red; /* White background */
  border-color: #e7e7e7; /* Light gray border */
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1); /* Subtle shadow */
  font-size: 0.8rem; /* Adjust font size as needed */
  padding: 10px; /* Inner padding */
}

.popover .popover-header {
  /* Remove header border and background for a cleaner look */
  border: none;
  background-color: transparent;
  padding: 0; /* Remove top/bottom padding */
}

.popover .popover-body {
  /* Remove default padding for a tighter fit */
  padding: 0;
}

#popover-basic {
  max-width: 880px !important;
  max-height: 537px !important;
  height: 537px;
  color: black;
  font-size: 20px;
  font-family: Literata;
  font-weight: 400;
  overflow-wrap: break-word;
  left: 55px !important;
}

.popover .popover-arrow {
  left: -55px !important;
}

.question-number:hover {
  opacity: 0.8;
  /* Adjust opacity as per your preference */
}

.options-main-div {
  display: flex;
  align-items: center;
  margin-bottom: 7px;
}

.option {
  position: relative;
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  border-radius: 5px;
  padding: 8px;
  width: 100%;
  margin-right: 5px;
}
.option.eliminated {
  color: #aaa;
  background-color: #f0f0f0;
}
.option.eliminated::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 1px;
  background: #000;
  transform: translateY(-50%);
}

.option-index {
  min-width: 25px;
  height: 25px;
  border-radius: 12.5px;
  background: transparent;
  border: solid black 1px;
  margin-right: 5px;
  color: black;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.eliminate-button {
  margin-left: "auto";
  border: none;
  background-color: transparent;
}
.eliminate-button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.undo-button {
  background-color: transparent;
  text-decoration: underline;
  border: none;
}

.circular-progress-background {
  transition: stroke-dashoffset 0.35s;
  transform: rotate(-90deg);
  transform-origin: 50% 50%;
}

.circular-progress-bar {
  transition: stroke-dashoffset 0.35s;
  transform: rotate(-90deg);
  transform-origin: 50% 50%;
}

.score-breakdown {
  margin-top: 50px !important;
}

.section-header td {
  background-color: lightgray !important;
}

/* Container for the questions to ensure it scrolls independently */
.questions-container {
  /* Add right margin to avoid overlap with numbering card */
  overflow-y: auto; /* Enable scrolling */
  scrollbar-width: none; /* Hides scrollbar for Firefox */
  -ms-overflow-style: none;
}

.question-without-scroll {
  overflow-y: auto; /* Enable scrolling */
  scrollbar-width: none; /* Hides scrollbar for Firefox */
  -ms-overflow-style: none;
}

.questions-container::-webkit-scrollbar {
  display: none;
}

.question-without-scroll::-webkit-scrollbar {
  display: none;
}

.questions-numbering-container-result {
  position: sticky !important;
  top: 94px !important;
  background: white;
  z-index: 1;
}

.exam-options-container {
  margin: 0;
}

.status-label {
  font-size: 0.9em;
  font-weight: bold;
}

.status-label.correct-result {
  color: #28a745;
}

.status-label.incorrect-result {
  color: #dc3545;
}

.correct-numerical-result {
  color: #28a745;
  font-size: 0.9em;
  font-weight: bold;
}

.incorrect-numerical-result {
  color: #dc3545;
  font-size: 0.9em;
  font-weight: bold;
}

/* Style for the option items */
.option-item-result {
  padding: 5px;
  margin-bottom: 5px;
  border: 2px solid #ccc;
  border-radius: 5px;
  display: flex;
  align-items: center;
}

/* Style for the correct-result option */
.option-item-result.correct-result {
  border-color: green;
}

.option-item-result.incorrect-result {
  border-color: red;
}

/* Style for the status label */
.status-label {
  padding: 3px 6px;
  border-radius: 5px;
  font-weight: bold;
}

/* Style for different status labels */
.status-label.correct-result {
  background-color: green;
  color: white;
}

.status-label.incorrect-result {
  background-color: red;
  color: white;
}

.status-label.unanswered {
  background-color: orange;
  color: white;
}

@media (min-width: 768px) and (max-width: 1024px) {
  .exam-options-container {
    margin: 0 !important;
    font-size: 0.7rem;
  }
}
@media (max-width: 767px) {
  .exam-options-container {
    font-size: 0.6rem;
  }
}
.exam-options-container img {
  width: 100%;
  height: auto;
  display: block;
  max-width: 100%;
}

.exam-header-row {
  flex-wrap: nowrap !important;
}

.exam-header-section-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}

@media (min-width: 768px) and (max-width: 1024px) {
  .exam-header-row {
    flex-wrap: nowrap !important;
    min-width: 0;
  }
  .exam-header-section-name {
    font-size: 1rem !important;
    max-width: 220px;
    min-width: 0;
    padding-right: 8px;
  }
  .px-5 {
    padding-left: 0.75rem !important;
    padding-right: 0.75rem !important;
  }
}
@media (max-width: 1024px) {
  .user-response-summary {
    font-size: 0.92em !important;
    overflow-x: auto;
    padding: 6px !important;
  }
  .user-response-summary table {
    min-width: 700px;
    font-size: 0.95em !important;
  }
  .user-response-summary th,
  .user-response-summary td {
    padding: 4px 6px !important;
    font-size: 0.95em !important;
  }
  .user-response-summary .section-header td {
    font-size: 1em !important;
    padding: 6px 8px !important;
  }
  .result-page-summary-container {
    display: flex !important;
    flex-direction: row !important;
    align-items: flex-start !important;
    gap: 16px !important;
  }
  .numbering-container {
    width: 120px !important;
    min-width: 100px !important;
    max-width: 130px !important;
    background: #fffbe7;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);
    padding: 10px 6px !important;
    margin: 0 !important;
    position: sticky !important;
    top: 70px !important;
    z-index: 10;
    border: 1px solid #f3e6b8;
  }
  .questions-container,
  .question-without-scroll {
    flex: 1 1;
    max-width: calc(100% - 140px) !important;
    min-width: 0;
    padding: 0 !important;
  }
  .detail-summary {
    font-size: 0.97em !important;
  }
  .option-item-result {
    font-size: 0.97em !important;
    padding: 4px 6px !important;
  }
  .status-label {
    font-size: 0.97em !important;
  }
}
@media (max-width: 768px) {
  .result-page-summary-container {
    flex-direction: column !important;
    gap: 10px !important;
  }
  .numbering-container {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    position: static !important;
    margin-bottom: 10px !important;
    box-shadow: none;
    border-radius: 8px;
    border: 1px solid #f3e6b8;
  }
  .questions-container,
  .question-without-scroll {
    max-width: 100% !important;
  }
}
.question-navbar-sticky {
  position: sticky;
  top: 0;
  z-index: 20;
  background: #fffbe7;
  border-bottom: 1px solid #f3e6b8;
  padding: 10px 0 6px 0;
  display: flex;
  gap: 8px;
  overflow-x: auto;
  white-space: nowrap;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  padding-right: 24px !important;
}

.question-navbar-btn {
  background: #fff;
  border: 1.5px solid #f3e6b8;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  min-width: 36px;
  min-height: 36px;
  font-weight: 600;
  color: #314cc6;
  font-size: 1.1em;
  cursor: pointer;
  transition: background 0.15s, border 0.15s;
  outline: none;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.question-navbar-btn:hover,
.question-navbar-btn:focus {
  background: #f3e6b8;
  border-color: #314cc6;
}

.question-navbar-btn-correct {
  border-color: #28a745 !important;
  box-shadow: 0 0 0 2px #e6f9ed;
}

.question-navbar-btn-incorrect {
  border-color: #dc3545 !important;
  box-shadow: 0 0 0 2px #faeaea;
}

.question-navbar-btn-skipped {
  border-color: #ff9800 !important;
  box-shadow: 0 0 0 2px #fff5e0;
}

@media (max-width: 1024px) {
  .question-navbar-sticky {
    top: 56px;
    padding: 8px 0 4px 0;
    gap: 6px;
  }
  .question-navbar-btn {
    width: 32px;
    height: 32px;
    min-width: 32px;
    min-height: 32px;
    font-size: 1em;
  }
}
@media (max-width: 768px) {
  .question-navbar-sticky {
    top: 48px;
    padding: 6px 0 2px 0;
    gap: 4px;
  }
  .question-navbar-btn {
    width: 28px;
    height: 28px;
    min-width: 28px;
    min-height: 28px;
    font-size: 0.95em;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/StudentDashboard/WroongQuestionsReport/styles.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA,EAAA,qBAAA;EACA,qBAAA,EAAA,sBAAA;EACA,wCAAA,EAAA,kBAAA;EACA,iBAAA,EAAA,+BAAA;EACA,aAAA,EAAA,kBAAA;AACF;;AAEA;EACE,2DAAA;EACA,YAAA;EACA,6BAAA;EACA,UAAA,EAAA,8BAAA;AACF;;AAEA;EACE,6CAAA;EACA,UAAA;AACF;;AAEA;EACE,2BAAA;EACA,4BAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,YAAA;EACA,0CAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;AACF;AAAE;EACE,WAAA;EACA,yBAAA;AAEJ;AADI;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,2BAAA;AAGN;;AAEA;EACE,eAAA;EACA,YAAA;EACA,qBAAA;EACA,uBAAA;EACA,uBAAA;EACA,iBAAA;EACA,YAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,mBAAA;EACA,YAAA;EACA,6BAAA;AACF;AAAE;EAEE,mBAAA;EACA,YAAA;AACJ;;AAGA;EACE,6BAAA;EACA,0BAAA;EACA,YAAA;AAAF;;AAGA;EACE,mCAAA;EACA,yBAAA;EACA,yBAAA;AAAF;;AAGA;EACE,mCAAA;EACA,yBAAA;EACA,yBAAA;AAAF;;AAGA;EACE,2BAAA;AAAF;;AAGA;EACE,sCAAA;AAAF;;AAGA,mEAAA;AACA;EACE,0DAAA;EACA,gBAAA,EAAA,qBAAA;EACA,qBAAA,EAAA,gCAAA;EACA,wBAAA;AAAF;;AAGA;EACE,gBAAA,EAAA,qBAAA;EACA,qBAAA,EAAA,gCAAA;EACA,wBAAA;AAAF;;AAEA;EACE,aAAA;AACF;;AACA;EACE,aAAA;AAEF;;AACA;EACE,2BAAA;EACA,oBAAA;EACA,iBAAA;EACA,UAAA;AAEF;;AACA;EAEE,SAAA;AACF;;AAEE;EACE,gBAAA;EACA,iBAAA;AACJ;;AAEE;EACE,cAAA;AACJ;;AAEE;EACE,cAAA;AACJ;;AAEE;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;AACJ;;AAEE;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;AACJ;;AACE,+BAAA;AACA;EACE,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AAEJ;;AACE,wCAAA;AACA;EACE,mBAAA;AAEJ;;AACE;EACE,iBAAA;AAEJ;;AACE,+BAAA;AACA;EACE,gBAAA;EACA,kBAAA;EACA,iBAAA;AAEJ;;AACE,sCAAA;AACA;EACE,uBAAA;EACA,YAAA;AAEJ;;AACE;EACE,qBAAA;EACA,YAAA;AAEJ;;AACE;EACE,wBAAA;EACA,YAAA;AAEJ;;AACA;EACE;IAEE,oBAAA;IACA,iBAAA;EACF;AACF;AACA;EACE;IACE,iBAAA;EACF;AACF;AAEA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AAAF;;AAGA;EACE,4BAAA;AAAF;;AAEA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AACF;;AACA;EACE;IACE,4BAAA;IACA,YAAA;EAEF;EAAA;IACE,0BAAA;IACA,gBAAA;IACA,YAAA;IACA,kBAAA;EAEF;EAAA;IACE,gCAAA;IACA,iCAAA;EAEF;AACF;AACA;EACE;IACE,4BAAA;IACA,gBAAA;IACA,uBAAA;EACF;EACA;IACE,gBAAA;IACA,4BAAA;EACF;EACA;;IAEE,2BAAA;IACA,4BAAA;EACF;EACA;IACE,yBAAA;IACA,2BAAA;EACF;EACA;IACE,wBAAA;IACA,8BAAA;IACA,kCAAA;IACA,oBAAA;EACF;EACA;IACE,uBAAA;IACA,2BAAA;IACA,2BAAA;IACA,mBAAA;IACA,mBAAA;IACA,yCAAA;IACA,4BAAA;IACA,oBAAA;IACA,2BAAA;IACA,oBAAA;IACA,WAAA;IACA,yBAAA;EACF;EACA;;IAEE,SAAA;IACA,wCAAA;IACA,YAAA;IACA,qBAAA;EACF;EACA;IACE,4BAAA;EACF;EACA;IACE,4BAAA;IACA,2BAAA;EACF;EACA;IACE,4BAAA;EACF;AACF;AAEA;EACE;IACE,iCAAA;IACA,oBAAA;EAAF;EAEA;IACE,sBAAA;IACA,0BAAA;IACA,uBAAA;IACA,2BAAA;IACA,8BAAA;IACA,gBAAA;IACA,kBAAA;IACA,yBAAA;EAAF;EAEA;;IAEE,0BAAA;EAAF;AACF;AAGA;EACE,gBAAA;EACA,MAAA;EACA,WAAA;EACA,mBAAA;EACA,gCAAA;EACA,qBAAA;EACA,aAAA;EACA,QAAA;EACA,gBAAA;EACA,mBAAA;EACA,yCAAA;EACA,8BAAA;AADF;;AAGA;EACE,gBAAA;EACA,2BAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,0CAAA;EACA,aAAA;EACA,yCAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AAAF;;AAEA;;EAEE,mBAAA;EACA,qBAAA;AACF;;AACA;EACE,gCAAA;EACA,6BAAA;AAEF;;AAAA;EACE,gCAAA;EACA,6BAAA;AAGF;;AADA;EACE,gCAAA;EACA,6BAAA;AAIF;;AADA;EACE;IACE,SAAA;IACA,oBAAA;IACA,QAAA;EAIF;EAFA;IACE,WAAA;IACA,YAAA;IACA,eAAA;IACA,gBAAA;IACA,cAAA;EAIF;AACF;AAFA;EACE;IACE,SAAA;IACA,oBAAA;IACA,QAAA;EAIF;EAFA;IACE,WAAA;IACA,YAAA;IACA,eAAA;IACA,gBAAA;IACA,iBAAA;EAIF;AACF","sourcesContent":[".popover {\n  background-color: red; /* White background */\n  border-color: #e7e7e7; /* Light gray border */\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1); /* Subtle shadow */\n  font-size: 0.8rem; /* Adjust font size as needed */\n  padding: 10px; /* Inner padding */\n}\n\n.popover .popover-header {\n  /* Remove header border and background for a cleaner look */\n  border: none;\n  background-color: transparent;\n  padding: 0; /* Remove top/bottom padding */\n}\n\n.popover .popover-body {\n  /* Remove default padding for a tighter fit */\n  padding: 0;\n}\n\n#popover-basic {\n  max-width: 880px !important;\n  max-height: 537px !important;\n  height: 537px;\n  color: black;\n  font-size: 20px;\n  font-family: Literata;\n  font-weight: 400;\n  overflow-wrap: break-word;\n  left: 55px !important;\n}\n\n.popover .popover-arrow {\n  left: -55px !important;\n}\n\n.question-number:hover {\n  opacity: 0.8;\n  /* Adjust opacity as per your preference */\n}\n\n.options-main-div {\n  display: flex;\n  align-items: center;\n  margin-bottom: 7px;\n}\n\n.option {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  cursor: pointer;\n  border-radius: 5px;\n  padding: 8px;\n  width: 100%;\n  margin-right: 5px;\n  &.eliminated {\n    color: #aaa; // Grey out the text to make it look disabled\n    background-color: #f0f0f0; // Optionally change the background to indicate it's disabled\n    &::after {\n      content: \"\";\n      position: absolute;\n      top: 50%;\n      left: 0; // Extend the line 3px beyond the left side\n      right: 0; // Extend the line 3px beyond the right side\n      height: 1px; // Line thickness\n      background: #000; // Line color\n      transform: translateY(-50%); // Center the line vertically\n    }\n  }\n}\n\n.option-index {\n  min-width: 25px;\n  height: 25px;\n  border-radius: 12.5px;\n  background: transparent;\n  border: solid black 1px;\n  margin-right: 5px;\n  color: black;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.eliminate-button {\n  margin-left: \"auto\";\n  border: none;\n  background-color: transparent;\n  &:disabled {\n    // Style for the disabled state\n    cursor: not-allowed;\n    opacity: 0.5;\n  }\n}\n\n.undo-button {\n  background-color: transparent;\n  text-decoration: underline;\n  border: none;\n}\n\n.circular-progress-background {\n  transition: stroke-dashoffset 0.35s;\n  transform: rotate(-90deg);\n  transform-origin: 50% 50%;\n}\n\n.circular-progress-bar {\n  transition: stroke-dashoffset 0.35s;\n  transform: rotate(-90deg);\n  transform-origin: 50% 50%;\n}\n\n.score-breakdown {\n  margin-top: 50px !important;\n}\n\n.section-header td {\n  background-color: lightgray !important;\n}\n\n/* Container for the questions to ensure it scrolls independently */\n.questions-container {\n  /* Add right margin to avoid overlap with numbering card */\n  overflow-y: auto; /* Enable scrolling */\n  scrollbar-width: none; /* Hides scrollbar for Firefox */\n  -ms-overflow-style: none;\n}\n\n.question-without-scroll {\n  overflow-y: auto; /* Enable scrolling */\n  scrollbar-width: none; /* Hides scrollbar for Firefox */\n  -ms-overflow-style: none;\n}\n.questions-container::-webkit-scrollbar {\n  display: none;\n}\n.question-without-scroll::-webkit-scrollbar {\n  display: none;\n}\n\n.questions-numbering-container-result {\n  position: sticky !important;\n  top: 94px !important;\n  background: white;\n  z-index: 1;\n}\n\n.exam-options-container {\n  // padding-top: 87px;\n  margin: 0;\n}\n\n  .status-label {\n    font-size: 0.9em;\n    font-weight: bold;\n  }\n\n  .status-label.correct-result {\n    color: #28a745;\n  }\n\n  .status-label.incorrect-result {\n    color: #dc3545;\n  }\n\n  .correct-numerical-result {\n    color: #28a745;\n    font-size: 0.9em;\n    font-weight: bold;\n  }\n\n  .incorrect-numerical-result {\n    color: #dc3545;\n    font-size: 0.9em;\n    font-weight: bold;\n  }\n  /* Style for the option items */\n  .option-item-result {\n    padding: 5px;\n    margin-bottom: 5px;\n    border: 2px solid #ccc;\n    border-radius: 5px;\n    display: flex;\n    align-items: center;\n  }\n\n  /* Style for the correct-result option */\n  .option-item-result.correct-result {\n    border-color: green;\n  }\n\n  .option-item-result.incorrect-result {\n    border-color: red;\n  }\n\n  /* Style for the status label */\n  .status-label {\n    padding: 3px 6px;\n    border-radius: 5px;\n    font-weight: bold;\n  }\n\n  /* Style for different status labels */\n  .status-label.correct-result {\n    background-color: green;\n    color: white;\n  }\n\n  .status-label.incorrect-result {\n    background-color: red;\n    color: white;\n  }\n\n  .status-label.unanswered {\n    background-color: orange;\n    color: white;\n  }\n\n@media (min-width: 768px) and (max-width: 1024px) {\n  .exam-options-container {\n    // padding-top: 87px !important;\n    margin: 0 !important;\n    font-size: 0.7rem;\n  }\n}\n@media (max-width: 767px) {\n  .exam-options-container {\n    font-size: 0.6rem;\n  }\n}\n\n.exam-options-container img {\n  width: 100%;\n  height: auto;\n  display: block;\n  max-width: 100%;\n}\n\n.exam-header-row {\n  flex-wrap: nowrap !important;\n}\n.exam-header-section-name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 100%;\n}\n@media (min-width: 768px) and (max-width: 1024px) {\n  .exam-header-row {\n    flex-wrap: nowrap !important;\n    min-width: 0;\n  }\n  .exam-header-section-name {\n    font-size: 1rem !important;\n    max-width: 220px;\n    min-width: 0;\n    padding-right: 8px;\n  }\n  .px-5 {\n    padding-left: 0.75rem !important;\n    padding-right: 0.75rem !important;\n  }\n}\n\n@media (max-width: 1024px) {\n  .user-response-summary {\n    font-size: 0.92em !important;\n    overflow-x: auto;\n    padding: 6px !important;\n  }\n  .user-response-summary table {\n    min-width: 700px;\n    font-size: 0.95em !important;\n  }\n  .user-response-summary th,\n  .user-response-summary td {\n    padding: 4px 6px !important;\n    font-size: 0.95em !important;\n  }\n  .user-response-summary .section-header td {\n    font-size: 1em !important;\n    padding: 6px 8px !important;\n  }\n  .result-page-summary-container {\n    display: flex !important;\n    flex-direction: row !important;\n    align-items: flex-start !important;\n    gap: 16px !important;\n  }\n  .numbering-container {\n    width: 120px !important;\n    min-width: 100px !important;\n    max-width: 130px !important;\n    background: #fffbe7;\n    border-radius: 10px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);\n    padding: 10px 6px !important;\n    margin: 0 !important;\n    position: sticky !important;\n    top: 70px !important;\n    z-index: 10;\n    border: 1px solid #f3e6b8;\n  }\n  .questions-container,\n  .question-without-scroll {\n    flex: 1 1 0%;\n    max-width: calc(100% - 140px) !important;\n    min-width: 0;\n    padding: 0 !important;\n  }\n  .detail-summary {\n    font-size: 0.97em !important;\n  }\n  .option-item-result {\n    font-size: 0.97em !important;\n    padding: 4px 6px !important;\n  }\n  .status-label {\n    font-size: 0.97em !important;\n  }\n}\n\n@media (max-width: 768px) {\n  .result-page-summary-container {\n    flex-direction: column !important;\n    gap: 10px !important;\n  }\n  .numbering-container {\n    width: 100% !important;\n    max-width: 100% !important;\n    min-width: 0 !important;\n    position: static !important;\n    margin-bottom: 10px !important;\n    box-shadow: none;\n    border-radius: 8px;\n    border: 1px solid #f3e6b8;\n  }\n  .questions-container,\n  .question-without-scroll {\n    max-width: 100% !important;\n  }\n}\n\n.question-navbar-sticky {\n  position: sticky;\n  top: 0;\n  z-index: 20;\n  background: #fffbe7;\n  border-bottom: 1px solid #f3e6b8;\n  padding: 10px 0 6px 0;\n  display: flex;\n  gap: 8px;\n  overflow-x: auto;\n  white-space: nowrap;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n  padding-right: 24px !important;\n}\n.question-navbar-btn {\n  background: #fff;\n  border: 1.5px solid #f3e6b8;\n  border-radius: 50%;\n  width: 36px;\n  height: 36px;\n  min-width: 36px;\n  min-height: 36px;\n  font-weight: 600;\n  color: #314cc6;\n  font-size: 1.1em;\n  cursor: pointer;\n  transition: background 0.15s, border 0.15s;\n  outline: none;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n.question-navbar-btn:hover,\n.question-navbar-btn:focus {\n  background: #f3e6b8;\n  border-color: #314cc6;\n}\n.question-navbar-btn-correct {\n  border-color: #28a745 !important;\n  box-shadow: 0 0 0 2px #e6f9ed;\n}\n.question-navbar-btn-incorrect {\n  border-color: #dc3545 !important;\n  box-shadow: 0 0 0 2px #faeaea;\n}\n.question-navbar-btn-skipped {\n  border-color: #ff9800 !important;\n  box-shadow: 0 0 0 2px #fff5e0;\n}\n\n@media (max-width: 1024px) {\n  .question-navbar-sticky {\n    top: 56px;\n    padding: 8px 0 4px 0;\n    gap: 6px;\n  }\n  .question-navbar-btn {\n    width: 32px;\n    height: 32px;\n    min-width: 32px;\n    min-height: 32px;\n    font-size: 1em;\n  }\n}\n@media (max-width: 768px) {\n  .question-navbar-sticky {\n    top: 48px;\n    padding: 6px 0 2px 0;\n    gap: 4px;\n  }\n  .question-navbar-btn {\n    width: 28px;\n    height: 28px;\n    min-width: 28px;\n    min-height: 28px;\n    font-size: 0.95em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
